import React from 'react';
import { Box } from '@mui/system';

import { IconButton, Tooltip, Typography } from '@mui/material';

import CallEndIcon from '@mui/icons-material/CallEnd';
import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from '@mui/icons-material/MicOff';
import VideocamIcon from '@mui/icons-material/Videocam';
import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import SettingsIcon from '@mui/icons-material/Settings';

const VideoCallControlBar = React.forwardRef(({
  roomName,
  isVideoOn,
  isAudioOn,
  updateVideoStatus,
  updateAudioStatus,
  endCall,
  openMediaDeviceSelection,
  enableMediaSelection,
},ref) => {
  const cameraButtonToolTip = isVideoOn ? 'Turn Off Camera' : 'Turn On Camera';
  const micButtonToolTip = isAudioOn ? 'Mute Mic' : 'Unmute Mic' ;
  const settingButtonToolTop = 'Settings';

  return (
    <Box
      ref={ref}
      sx={{
        display: 'flex',
        width: '100vw',
        position: 'fixed',
        bottom: 0,
        alignItems: 'center',
        py: '15px',
        zIndex: 50,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'start',
          flexGrow: 1,
          flexShrink: 1,
          flexBasis: '25%',
          ml: '12px',
        }}
      >
        <Typography
          variant="h5"
          color="white"
        >
          {roomName}
        </Typography>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          flexShrink: 1,
          flexBasis: '25%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Tooltip title={micButtonToolTip}>
          <IconButton
            onClick={updateAudioStatus}
            aria-label={micButtonToolTip}
            sx={{
              borderRadius: '50%',
              border: 1,
              borderColor: 'white',
              mr: '15px'
            }}
          >
            {
              isAudioOn ?
              <MicIcon sx={{color: 'lightgray'}} /> :
              <MicOffIcon sx={{color: 'red'}} />
            }
          </IconButton>
        </Tooltip>
        <Tooltip title={cameraButtonToolTip}>
          <IconButton
            onClick={updateVideoStatus}
            aria-label={cameraButtonToolTip}
            sx={{
              borderRadius: '50%',
              border: 1,
              borderColor: 'white',
              mr: '15px'
            }}
          >
            {
              isVideoOn ?
              <VideocamIcon sx={{color: 'lightgray'}} /> :
              <VideocamOffIcon sx={{color: 'red'}} />
            }
          </IconButton>
        </Tooltip>
        <Tooltip title="End Call">
          <IconButton
            onClick={endCall}
            aria-label='End Call'
            sx={{
              borderRadius: '50%',
              backgroundColor: 'red',
              '&:hover': {
                backgroundColor: 'red', // Button remains to be red when cursor hovers above it
              }
            }}
          >
            <CallEndIcon sx={{color: 'lightgray'}} />
          </IconButton>
          </Tooltip>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          flexShrink: 1,
          flexBasis: '25%',
          display: 'flex',
          justifyContent: 'flex-end',
          mr: '12px'
        }}
      >
       { 
          enableMediaSelection &&
          <IconButton
            onClick={openMediaDeviceSelection}
            aria-label={settingButtonToolTop}
            sx={{
              borderColor: 'white',
              mr: '15px'
            }}
          >
              <SettingsIcon sx={{color: 'lightgrey'}}/>
          </IconButton>
        }
      </Box>
    </Box>
  );
});

VideoCallControlBar.displayName = 'VideoCallControlBar';

export default VideoCallControlBar;